import clsx from 'clsx';
import { useGuardioes } from './useGuardioes';

interface SeloGuardiaoProps {
  email?: string | null;
  colaboradorId?: string | null;
  className?: string;
}

/**
 * Selo de Guardião dos Dados ao lado do nome — só aparece se a pessoa concluiu com aproveitamento
 * (e, em teste, só pra quem já tem a pílula liberada). Dica ao passar o mouse: "Guardião dos Dados".
 * Componente único: é só colocá-lo ao lado do nome em qualquer tela.
 */
export function SeloGuardiao({ email, colaboradorId, className }: SeloGuardiaoProps) {
  const { liberado, guardiaoDe } = useGuardioes();
  if (!liberado || !guardiaoDe({ email, colaboradorId })) return null;
  return (
    <span
      title="Guardião dos Dados"
      aria-label="Guardião dos Dados"
      className={clsx(
        'ml-1 inline-grid h-4 w-4 shrink-0 place-items-center rounded-full bg-primary-600 align-middle text-[9px] leading-none text-white',
        className
      )}
    >
      🛡
    </span>
  );
}
